module.exports = __webpack_public_path__ + "36089738b7dc6e2e192e590c51271f66.png";